import React from 'react';

const PlanSliders = ({ sliders }) => (
  <div>
    {sliders.social && (
      <div>
        <div className="plan-slider" data-user-slider="social" />
        <div
          className="plan-data"
          data-toggle="tooltip"
          data-placement="top"
          title="A user that has authenticated with username/password, passwordless connections or any social provider in the last 30 days, counted per tenant."
        >
          <span data-user-count="social" />
          <span className="slider-detail"> Regular Active Users</span>
          <span className="tip-icon" />
        </div>
      </div>
    )}
    {sliders.free && <div className="plan-data" />}
    {sliders.developer && <div className="plan-data" />}
    {sliders.enterprise && (
      <div>
        <div className="plan-slider" data-user-slider="enterprise" />
        <div
          className="plan-data"
          data-toggle="tooltip"
          data-placement="top"
          title="A user that has authenticated using an enterprise connection like SAML, Active Directory or LDAP among others in the last 30 days, counted per tenant."
        >
          <span data-user-count="enterprise" />
          <span className="slider-detail"> Enterprise Active Users</span>
          <span className="tip-icon" />
        </div>
      </div>
    )}
    {sliders.employee && (
      <div>
        <div className="plan-slider" data-user-slider="employee" />
        <div
          className="plan-data"
          data-toggle="tooltip"
          data-placement="top"
          title="An internal employee of your company that authenticated with any connection or identity provider."
        >
          <span data-user-count="employee" />
          <span className="slider-detail"> employees</span>
          <span className="tip-icon" />
        </div>
      </div>
    )}
  </div>
);

export default PlanSliders;



// WEBPACK FOOTER //
// ./src/components/pricingPlans/components/planBox/PlanSliders.js